var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 1.5C3.98512 1.5 1 4.48512 1 8.16667C1 11.8482 3.98512 14.8333 7.66667 14.8333C11.3482 14.8333 14.3333 11.8482 14.3333 8.16667C14.3333 4.48512 11.3482 1.5 7.66667 1.5ZM10.128 10.6994L9.14583 10.6949L7.66667 8.93155L6.18899 10.6935L5.20536 10.6979C5.13988 10.6979 5.08631 10.6458 5.08631 10.5789C5.08631 10.5506 5.09673 10.5238 5.11458 10.5015L7.0506 8.19494L5.11458 5.88988C5.0966 5.86807 5.08662 5.84076 5.08631 5.8125C5.08631 5.74702 5.13988 5.69345 5.20536 5.69345L6.18899 5.69792L7.66667 7.46131L9.14435 5.69941L10.1265 5.69494C10.192 5.69494 10.2455 5.74702 10.2455 5.81399C10.2455 5.84226 10.2351 5.86905 10.2173 5.89137L8.28423 8.19643L10.2188 10.503C10.2366 10.5253 10.247 10.5521 10.247 10.5804C10.247 10.6458 10.1935 10.6994 10.128 10.6994Z",
    fill: "#9AA1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.541cd80a3e152b08a1e8b4b31d8274a8.svg";
export { ForwardRef as ReactComponent };